<template>
  <!-- On expose la méthode trigger au slot -->
  <slot :trigger="trigger"></slot>
</template>

<script>
import { defineComponent } from 'vue'
import Service from '../../dataService.js'
import sendBugAlert from '@/shared/errors/sendBugAlert.js'

export default defineComponent({
  name: 'ActionTrigger',
  emits: ['launching', 'success', 'failed'],
  props: {
    dataKey: { type: String, required: true },
  },
  methods: {
    async trigger(params = {}) {
      this.$emit('launching', { params })

      let result
      try {
        result = await Service.triggerAction(this.dataKey, params)
        if (!result) throw new Error('No result from action')
        await new Promise(r => setTimeout(r, 450))
        if (result.statusCode !== 200) {
          this.$emit('failed', { params, error: result.error, result })
          sendBugAlert(result.error, { params, result }, false)
        } else this.$emit('success', { params, result, error: null })
        return result
      } catch (error) {
        sendBugAlert(error, { params, result }, false)
        await new Promise(r => setTimeout(r, 450))
        this.$emit('failed', { params, error, result: null })
      }
    },
  },
})
</script>
